export default __webpack_public_path__ + "static/media/mag-logo2.554d8952.png";